import {Button as ButtonBase} from '@esgi/ui';
import {styled} from '@esgi/ui/theme';

export const Button = styled(ButtonBase.Icon, {
	color: '$negative',
});
